import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserStoreService } from './user-store.service';

export interface RequestTranslationsImportResult {
  files: TranslationsImportFileResult[]
};

export interface TranslationsImportFileResult {
  id: string,
  status: "created",
  relativePath: string
}

export interface TranslationsImportFileError {
	code: "TI400" | "TI401" | "TI409" | "TI502",
	description: string,
	details: any[],
	type: "BAD_REQUEST"
}

export type UploadType = "SurveyTranslations" | "GlobalTranslations";

@Injectable({ providedIn: 'root' })
export class ApiTranslationsImportService {
  private readonly apiBaseUrl = environment.apiBaseUrl;
  private readonly apiPath = "/translations/import";

  constructor(
    private http: HttpClient,
    private userStore: UserStoreService) {}

  requestTranslationsImport(organizationId: string, uploadType: UploadType, files: File[]): Observable<RequestTranslationsImportResult> {
    //Prevent update of other surveys during development, unless the user is a SuperAdmin
    if(organizationId != 'a535f93d-f8c7-421d-a9c9-74f7a17e3761' && !this.userStore.isSuperAdmin()){
      return throwError(() => new Error('You can\'t import translations for this organization/survey.'));
    }
    
    const formData = new FormData();
    formData.append('organizationId', organizationId);
    formData.append('uploadFile', uploadType);
    files.forEach(file => formData.append('files', file, file.name));

    return this.http.post<RequestTranslationsImportResult>(`${this.apiBaseUrl}${this.apiPath}`, formData);
  }
}
